module.exports = __webpack_public_path__ + "img/128.da5f19e2.jpg";